<template>
    <v-row justify="center">
        <v-dialog
            v-model="cellNumberDialog"
            :persistent='true'
            width="20%"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
            <div class="startTimeBody">
                <v-card class="cardWrap">
                <CardTitle title="組数選択"/>
                    <v-container>
                        <v-row align="center">
                            <v-col class="text-center" cols="2">組数</v-col>
                            <v-col class="text-center">
                                <v-text-field
                                    v-model="groupNum"
                                    type="number"
                                    />
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="onClose">閉じる</v-btn>
                        <v-btn color="primary" text @click="onNext">登録</v-btn>
                    </v-card-actions>
                    <StartTimeSelect
                        ref="StartTimeModal"
                        :received="passTo"
                        :childDialog="timeDialog"
                        @success="successClose($event)"
                        @close="closeModal"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import { utilityMixin } from '@/mixins/utility';
import CardTitle from '@/components/module/CardTitle';
import StartTimeSelect from './StartTimeSelect';

export default {
    components: {
        CardTitle,
        StartTimeSelect
    },
    props: {
        received: Object,
        cellNumberDialog: Boolean
    },
    mixins: [
        utilityMixin
    ],
    data () {
        return {
            planId: '',
            cellId: '',
            memberNo: '',
            playDate: '',
            groupNum: 0,
            oldGroupNum: 0,
            playerMin: 0,
            playerLeft: 0,
            playNumber: 0,
            reserveType: 0,
            oldPlayNumber: 0,
            plan_name: null,
            changeOverlay: false,
            timeDialog: false,
            processing: {
                result: '',
                resultText: ''
            },
            passTo: {
                cellId: '',
                planId: '',
                golfCode: '',
                reserveType: '',
                playDate: '',
                memberNo: '',
                memberClass: '0',
                cellIdList: []
            }
        };
    },
    methods: {
        /** ----------------------------------------------
         * 組数変更時のチェック
         * ---------------------------------------------- */
        async checkCellNumber () {
            var cell = Number(this.groupNum);
            this.$set(this.processing, 'result', '');
            this.$set(this.processing, 'resultText', '');
            if (cell <= 0) {
                this.$set(this.processing, 'result', '1');
                this.$set(this.processing, 'resultText', this.$t('error.validation.cell.cellmin'));
                return true;
            } else if (cell > Number(this.oldGroupNum)) {
                this.message = this.$t('message.cellUp');
                this.changeOverlay = false;
                return false;
            } else if (cell < Number(this.oldGroupNum)) {
                this.message = this.$t('message.cellDown');
                this.changeOverlay = false;
                return false;
            } else {
                this.$set(this.processing, 'result', '1');
                this.$set(this.processing, 'resultText', this.$t('error.validation.cell.nochange'));
                return true;
            }
        },
        /** ----------------------------------------------
         * 次へボタン処理
         * ---------------------------------------------- */
        async onNext () {
            if (await this.checkCellNumber()) {
                return;
            }
            var info = { reserveNo: this.reserveNo, groupNum: this.groupNum };
            if (this.message === this.$t('message.cellDown')) {
                this.$emit('open-delete-companion', info);
            } else if (this.message === this.$t('message.cellUp')) {
                this.$emit('open-update-cell', info);
            }
        },
        /** ----------------------------------------------
         * この画面を開く処理
         * ---------------------------------------------- */
        ModalControl (reserveNo, playNumber, groupNum, playerMin, reserveType, playerLeft, playerMax, cellId) {
            this.reserveNo = reserveNo;
            this.oldPlayNumber = playNumber;
            this.playNumber = playNumber;
            this.groupNum = groupNum;
            this.oldGroupNum = groupNum;
            this.playerMin = playerMin;
            this.playerMax = playerMax;
            this.reserveType = reserveType;
            this.playerLeft = playerLeft;
            this.cellId = cellId;
            /* this.passTo.cellId = cellId;
            this.passTo.planId = this.received.planId;
            this.passTo.planName = this.received.planName;
            this.passTo.reserveType = this.received.reserveType;
            this.passTo.golfCode = this.received.golfCode;
            this.passTo.reserveNo = this.received.reserveNo;
            this.passTo.playDate = this.received.playDate;
            this.passTo.memberNo = this.received.memberNo;
            this.passTo.reserveType = this.received.reserveType;
            this.passTo.memberClass = this.received.memberClass;
            this.passTo.cellIdList.push({ cellId: this.received.cellId, number: this.received.playNumber });
            // this.getPlan(this.passTo.playDate); */
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる処理
         * ---------------------------------------------- */
        closeChangeOverLay () {
            this.$set(this.processing, 'result', '');
            this.$set(this.processing, 'resultText', '');
            this.changeOverlay = false;
        },
        /** ----------------------------------------------
         * 閉じるボタン処理
         * ---------------------------------------------- */
        onClose () {
            this.$emit('close');
        },
        closeModal () {
            this.timeDialog = false;
            this.$emit('close');
        }
    }
};
</script>
